module.exports = __webpack_public_path__ + "static/selects-order-dont-1590bc72f8c246eb37fccad66da12a12.png";